import { menuModule } from '@menu/module';
import { optimizerModule } from '@optimizer/module';
import { optimizerProModule } from '@optimizerPro/module';
import { manualConfigModule } from '@manualConfig/module';
import { mastersModule } from '@masters/module';
import { reportingModule } from '@reporting/module';
import { fileExportModule } from '@fileExport/module';
import { mutations } from '@pointOfSale/mutations';
import { powerBiReportingModule } from '@powerBiReporting/module';
import { getters } from './getters';
import * as actions from './actions';
import { state } from './models';

export const pointOfSaleModule = {
  state,
  getters,
  actions,
  mutations,
  modules: {
    menu: menuModule,
    optimizer: optimizerModule,
    optimizerPro: optimizerProModule,
    manualConfig: manualConfigModule,
    reporting: reportingModule,
    masters: mastersModule,
    fileExport: fileExportModule,
    powerBiReporting: powerBiReportingModule
  },
};
